import http from "@/axios/index";

/**
 * @Author: lishiqiao
 * @Date: 2022-06-06 11:43:29
 * @description: 根据角色权限获取养殖场下拉列表
 */
export function getBaseListsByUser() {
    const url = '/baseData/queryBaseDataListByRole';
    return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-06 11:44:58
 * @description: 获取基地区域接口
 * @param {*} baseId 基地id
 */
export function queryBaseGroupList(baseId) {
    const url = '/baseGroup/queryBaseGroupList';
    return http.post(url, {
        baseId: baseId
    });
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-06 11:47:07
 * @description: 获取区域塘口接口
 * @param {*} groupId 区域id
 */
export function listDataPermissionBoxData(groupId) {
    const url = '/boxData/listDataPermissionBoxData/' + groupId;
    return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-06 11:50:21
 * @description: 获取出鱼操作类型列表
 * @param {*} type 0、1、2、3
 * 0. 投苗、补苗
 * 1. 分苗、移箱、分箱
 * 2. 销售、出鱼、清塘
 * 3. 投苗、补苗、移箱、分苗、转出、转入、分箱
 */
export function getOperationTypeList(type) {
    const url = '/seedlingItem/getSeedByType/' + type;
    return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-13 11:48:09
 * @description: 获取养殖品种下拉列表
 * @param {*} orgId 机构id
 */
export function getBreedList(orgId) {
    const url = '/breedData/getListMap/orgId/' + orgId;
    return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-13 13:32:55
 * @description: 根据机构id获取一级机构信息
 * @param {*} orgId 机构id
 */
export function getOrgInfoByOrgId(orgId) {
    const url = '/org/getParentOrg/' + orgId;
    return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-13 15:05:09
 * @description: 获取苗种类别
 */
export function getSeedlingType() {
    const url = '/sysDictionary/getListMap/type/seedlingType';
    return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-13 15:11:44
 * @description: 获取苗种名称
 * @param {*} orgId 机构id
 */
export function getListSeedlingInfo(orgId) {
    const url = '/seedlingInfo/listSeedlingInfo/' + orgId;
    return http.get(url);
}

/**
 * 根据机构id获取供应商列表
 * 使用：苗种采购、饲料采购、药品采购
 * 旧: /providerData/getListMap/orgId/
 * 新: /subProf/getProvList/
 * @param orgId 机构id
 */
export function getSuppliers(orgId) {
    const url = '/subProf/getProvList/' + orgId;
    return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-13 15:24:27
 * @description:  获取汇总类型
 */
export function getTotalType() {
    const url = '/seedlingItem/getGroupByTypeList';
    return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-13 16:08:38
 * @description: 获取列表数据分页
 * @param {*} postObj
 */
export function getListByPages(postObj) {
    const url = '/seedlingItem/getRecodeByPage';
    return http.post(url, postObj);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-13 23:28:21
 * @description: 下载模板
 */
export function downloadTemplate() {
    return '/fileDownload/downloadFile/downloadSeedlingItemTemplate';
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-13 23:37:59
 * @description: 导入
 */
export function fileupload() {
    return '/seedlingItem/importSeedItemTable';
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-13 23:45:17
 * @description: 导出
 */
export function getSeedlingRecordExportUrl() {
    return '/seedlingItem/conditionExportTable';
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-14 10:08:20
 * @description: 
 * @param {*} postObj
 */
export function getOptionsData(postObj) {
    const url = '/seedlingItem/bar';
    return http.post(url, postObj);
  }